import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

let sharedDracoLoader: DRACOLoader | null = null;

function getDracoLoader(): DRACOLoader {
  if (!sharedDracoLoader) {
    sharedDracoLoader = new DRACOLoader();
    // Served from public/vendor/ (dev) or dist/vendor/ (production build).
    sharedDracoLoader.setDecoderPath('/vendor/draco/gltf/');
    sharedDracoLoader.preload();
  }
  return sharedDracoLoader;
}

/** GLTFLoader with Draco decompression for compressed GLB/GLTF assets. */
export function createGltfLoader(): GLTFLoader {
  const loader = new GLTFLoader();
  loader.setDRACOLoader(getDracoLoader());
  return loader;
}
